import { addNavMenuItem } from '@vendure/admin-ui/core'

export default [
  addNavMenuItem(
    {
      id: 'gifts',
      label: 'gift-plugin.menu.label',
      routerLink: ['/extensions/gifts'],
      icon: 'crown',
    },
    'marketing',
  ),
]
